export default __webpack_public_path__ + "static/media/erro.36393147.png";